const MOBLY = 'MOBLY'
const TOKSTOK = 'TOKSTOK'
const SUPPORT = 'SUPPORT'
const POSSIBLE_ORGANIZATIONS_VALUE = [MOBLY, TOKSTOK, SUPPORT]

export {
  MOBLY,
  TOKSTOK,
  SUPPORT,
  POSSIBLE_ORGANIZATIONS_VALUE
}
